import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TCreateEmployeePaycardSsnInquiryRequest,
  TCreatePaycardSsnInquiryResponse,
} from "./createEmployeePaycardSsnInquiry.schema";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const createEmployeePaycardSsnInquiry = (axios: IAxiosInstance) => {
  return async ({
    workerId,
  }: TCreateEmployeePaycardSsnInquiryRequest): Promise<TCreatePaycardSsnInquiryResponse> => {
    const {data} = await axios.noRetry.post<IApiResponse<TCreatePaycardSsnInquiryResponse>>(
      `/api/employees/${workerId}/paycards/ssn-inquiry`
    );

    return data.data;
  };
};
